// Unified status color configuration for the entire app
export const STATUS_COLORS = {
  // Package submission statuses
  draft: 'bg-gray-100 text-gray-800 border border-white',
  not_sent: 'bg-gray-100 text-gray-800',
  sent: 'bg-red-100 text-red-800', // 好看的暗红色
  received: 'bg-red-100 text-red-800', // 好看的暗红色
  viewed: 'bg-purple-100 text-purple-800', // 紫色
  downloaded: 'bg-orange-100 text-orange-800', // 黄橙色
  tender_returned: 'bg-blue-100 text-blue-800', // 蓝色
  awarded: 'bg-emerald-100 text-emerald-800', // 翠绿色
  awarded_and_closed: 'bg-emerald-100 text-emerald-800', // 翠绿色
  won: 'bg-emerald-100 text-emerald-800', // 翠绿色
  lost: 'bg-red-100 text-red-800',
  rejected: 'bg-red-100 text-red-800', // 红色
  expired: 'bg-orange-100 text-orange-800',
} as const;

// Helper function to get status color
export function getStatusColor(status: string): string {
  return STATUS_COLORS[status.toLowerCase() as keyof typeof STATUS_COLORS] || 'bg-gray-100 text-gray-800';
}

// Status configuration with labels and icons
export const STATUS_CONFIG = {
  draft: { label: "Draft", color: STATUS_COLORS.draft },
  not_sent: { label: "Draft", color: STATUS_COLORS.not_sent },
  sent: { label: "Sent", color: STATUS_COLORS.sent },
  received: { label: "Received", color: STATUS_COLORS.received },
  viewed: { label: "Viewed", color: STATUS_COLORS.viewed },
  downloaded: { label: "Downloaded", color: STATUS_COLORS.downloaded },
  tender_returned: { label: "Returned", color: STATUS_COLORS.tender_returned },
  awarded: { label: "Awarded", color: STATUS_COLORS.awarded },
  awarded_and_closed: { label: "Awarded", color: STATUS_COLORS.awarded_and_closed },
  won: { label: "Won", color: STATUS_COLORS.won },
  lost: { label: "Lost", color: STATUS_COLORS.lost },
  rejected: { label: "Rejected", color: STATUS_COLORS.rejected },
  expired: { label: "Expired", color: STATUS_COLORS.expired },
} as const;
